import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';
import { StorageMetricDto } from '../types/StorageMetricDto';

export const getStorageMetrics = async (): Promise<StorageMetricDto> => {
  const { data } = await axios.get(`/api/database-metrics/storage`);
  return data as StorageMetricDto;
};

type QueryFnType = typeof getStorageMetrics;

type UseStorageMetricsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useStorageMetrics = ({ config }: UseStorageMetricsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['storageMetrics'],
    queryFn: () => getStorageMetrics(),
  });
};
